import React from 'react';
import { Add, ArrowForwardIos, AutoAwesome, StickyNote2 } from '@mui/icons-material';
import { Button, Fab, Tooltip } from '@mui/material';
import GlowBorder from '../../../common/GlowBorder';
import './CanvasButtons.css';

/** Density shell — colors from Theme MuiButton (variant/color). */
export const CanvasHeaderButton = React.forwardRef(function CanvasHeaderButton(
  { sx, size = 'small', ...props },
  ref
) {
  return (
    <Button
      ref={ref}
      size={size}
      {...props}
      sx={{ px: 2, py: '2px', gap: '4px', fontSize: 14, borderRadius: '4px', ...sx }}
    />
  );
});

const sideMenuFabSx = {
  width: 40,
  height: 40,
  mb: 3,
  zIndex: 1000,
};

const CanvasSideMenuButton = ({ tooltip, onClick, icon, showClose, disabled }) => {
  return (
    <Tooltip title={tooltip}>
      <span style={{ display: 'inline-block' }}>
        <Fab size="small" disabled={disabled} onClick={onClick} sx={sideMenuFabSx}>
          {showClose ? <ArrowForwardIos className="canvasSideMenuIcon" /> : icon}
        </Fab>
      </span>
    </Tooltip>
  );
};

export const ComponentMenuCanvasButton = ({ onClick, showClose, disabled = false }) => {
  return (
    <CanvasSideMenuButton
      showClose={showClose}
      tooltip="Add a component"
      onClick={onClick}
      disabled={disabled}
      icon={<Add className="canvasSideMenuIcon" />}
    />
  );
};

export const NoteMenuCanvasButton = ({ onClick, showClose }) => {
  return (
    <CanvasSideMenuButton
      showClose={showClose}
      tooltip="Add a note"
      onClick={onClick}
      icon={<StickyNote2 className="canvasSideMenuIcon" />}
    />
  );
};

export const AIMenuCanvasButton = ({ onClick, active }) => {
  return (
    <Tooltip title={active ? 'Close AI Request' : 'AI Request'} placement="bottom" arrow>
      <GlowBorder
        onClick={onClick}
        style={{ cursor: 'pointer', marginRight: 8 }}
        size={30}
        borderRadius={5}
      >
        <AutoAwesome style={{ color: '#FFF', fontSize: 16 }} />
      </GlowBorder>
    </Tooltip>
  );
};
